module.exports = __webpack_public_path__ + "img/ui-elements-a4s.462cfd9e.svg";